import { render, staticRenderFns } from "./Adjustmentlimit.vue?vue&type=template&id=0613e99e&scoped=true"
import script from "./Adjustmentlimit.vue?vue&type=script&lang=js"
export * from "./Adjustmentlimit.vue?vue&type=script&lang=js"
import style0 from "./Adjustmentlimit.vue?vue&type=style&index=0&id=0613e99e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0613e99e",
  null
  
)

export default component.exports